// extracted by mini-css-extract-plugin
module.exports = {"logo":"Header_logo__3EQTd"};